export default [
  {
    title: 'زیره پلاس',
    icon: 'bx bx-store',
    children: [
      {
        title: 'ترم ها',
        route: { name: 'userspecialdiet' },
        resource: 'SpecialDietManager',
        action: 'show',
      },
      {
        title: 'رژیم ها',
        route: { name: 'listDedicatedDiet' },
        resource: 'SpecialDietFoodListManager',
        action: 'show',
      },
      {
        title: 'لیست های غذایی',
        route: { name: 'listDedicatedFoods' },
        resource: 'SpecialDietFoodListManager',
        action: 'show',
      },
      {
        title: 'پرسش و پاسخ',
        route: { name: 'dedicatedDietQuestion' },
        resource: 'QuestionManager',
        action: 'show',
      },
      {
        title: 'کالری ها',
        route: { name: 'listCalorie' },
        resource: 'SpecialDietCalorieManager',
        action: 'show',
      },
      {
        title: 'مکمل ها',
        route: { name: 'listSupplement' },
        resource: 'SupplementManager',
        action: 'show',
      },
      {
        title: 'توصیه ها',
        route: { name: 'listRecommended' },
        resource: 'RecommendManager',
        action: 'show',
      },
      {
        title: ' دسته بندی توصیه',
        route: { name: 'listRecommendedCategory' },
        resource: 'RecommendCategoryManager',
        action: 'show',
      },
      /*{
        title: 'پرداخت رژیم اختصاصی',
        route: { name: 'PaySpecialDiet' },
        resource: 'SpecialDietPaymentSms',
        action: 'show',
      },*/
    ],
  }]
